import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";
import CheckBox from "../../../../components/CheckBox";
// import { GLOBAL_CONSTANTS } from "../../../../global/constants";
import { Address } from "../../../../models/Address";
import { Country } from "../../../../models/Country";
import { LocalStorage } from "../../../../models/LocalStorage";
import { Paging } from "../../../../models/Paging";
import { apiCreateAddressBook, apiGetAddressBook, apiUpdateAddressBook } from "../../../../utils/api";
import { DEFAULT_COUNTRY } from "../../../../utils/constant";
import { getMessage } from "../../../../utils/utils";
// eslint-disable-next-line no-unused-vars
import AddressForm from "../../../checkoutPage/components/CustomerInfo/components/AddressForm";
import AddressItem from "../AddressItem";
import { DCStatic } from "../../../../models/DCStatic";
import SearchForm from "../../../../components/SearchForm";
import debounce from "lodash/fp/debounce";

const PER_PAGE = 10;

class AddressModal extends DComponent {
  constructor({
    parent,
    id,
    selectedId,
    listAddress = [],
    paging,
    perPage = PER_PAGE,
    onSelect = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AddressModal")
    }, true);
    this.selectedId = selectedId;
    this.listAddress = listAddress;
    this.paging = paging;
    this.perPage = perPage;
    this.onSelect = onSelect;
    /** @type {AddressForm} */
    this.addressForm = undefined;
    /** @type {[AddressItem]} */
    this.listRadio = [];
    /** @type {CheckBox} */
    this.checkSaveAddress = undefined;
    /** @type {SearchForm} */
    this.searchForm = undefined;
    this.render();
  }



  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AddressModal");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setUpLoading();
    let shippingTo = LocalStorage.getShippingList();
    let shipping = (LocalStorage.getShipping() || "").toUpperCase();
    this.checkSaveAddress = new CheckBox({
      parent: $(".check-save-address", this.element),
      labelI18n: "checkout_saveToAddressBookOrigin",
      checked: true,
      tabIndex: 110,
    })
    this.addressForm = new AddressForm({
      parent: $(".address-form", this.element),
      type: "modal",
      countryList: Country.getCountryList(),
      phoneOptions: {
        initialCountry: shippingTo?.length > 0 && shipping && shippingTo.includes(shipping) ? shipping : DEFAULT_COUNTRY
      },
      onDialCode: (code) => {
        this.addressForm.setAddressCountry(code);
      },
      tabIndex: 100,
      scrollParent: `#${this.id} .modal-content`,
    })
    $(".address-list", this.element).on("scroll", (e) => {
      if (($(e.currentTarget).scrollTop() + $(e.currentTarget).innerHeight() >= $(e.currentTarget)[0].scrollHeight - 24) && !$(`.address-list`, this.element).hasClass("load-more")) {
        this.loadMore();
      }
    });
    $(".group-button .btn-select", this.element).on("click", () => {
      this.onSelectedAddress();
      this.hide();
    })
    $(".group-button .btn-add-new", this.element).on("click", () => {
      if (LocalStorage.getShipping()) this.addressForm.phone.setCountry(LocalStorage.getShipping());
      this.addressForm.resetAddress();
      $(".modal-content", this.element).attr("type", "required-form").attr("mode", "new");
    })

    $(".group-button .btn-cancel", this.element).on("click", () => {
      this.addressForm.resetAddress();
      $(".modal-content", this.element).attr("type", "");
    })

    $(".group-button .btn-save", this.element).on("click", () => {
      if (this.addressForm.validateForm()) {
        if ($(".modal-content", this.element).attr("mode") === "new") {
          if (this.checkSaveAddress.getValue()) {
            this.onSave();
          } else {
            let newAddress = this.addressForm.getDataAddress();
            typeof this.onSelect == "function" && this.onSelect(newAddress);
            this.addressForm.resetAddress();
            this.hide();
          }
        } else {
          this.onSave();
        }
      }
    });

    $(".group-button .btn-login", this.element).on("click", () => {
      DCStatic.authSocial.setCallBack(() => { this.loginSuccess() });
      DCStatic.authSocial.showAuth();
      this.hide();
    });
    this.element.on("hide.bs.modal", () => {
      $("html, body").css("overflow", "auto");
      $(`.address-list .list-data`, this.element).scrollTop(0);
    });

    this.searchForm = new SearchForm({
      parent: $(".search-box", this.element),
      hideButton: true,
      noCheckValue: false,
      onSearch: () => this.search(),
      onClear: () => this.search(),
      onInput: () => this.searchDebounce(),
      placeholderI18n: "addressBook_placeholderSearch",
    });
  }

  search(page = 1, loadMore = false) {
    this.searchDebounce && this.searchDebounce.cancel();
    this.getAddressBook({
      page: page,
      per_page: this.perPage,
      id: this.selectedId,
      term: this.searchForm?.getValue(),
    }, loadMore);
  }

  searchDebounce = debounce(300)(this.search);

  onSelectedAddress() {
    let address = this.listAddress.find(item => item.id === this.selectedId);
    if (address) {
      typeof this.onSelect == "function" && this.onSelect(address);
    }
  }

  loginSuccess() {
    this.setUp();
    this.show();
  }

  /**
   * 
   * @param {AddressModal} _params 
   */
  setUp(_params = {}) {
    Object.keys(_params).forEach(key => {
      this[key] = _params[key];
    });

    $(`.address-list .list-data`, this.element).html("");
    if (this.listAddress.length > 0) {
      this.fillData(this.listAddress);
    } else {
      this.search();
    }
    // this.element.i18n();
  }

  loadMore() {
    const paging = this.paging;

    if (paging && paging.currentPage < paging.totalPages) {
      const newPage = paging.currentPage + 1;
      this.search(newPage, true);
    }
  }

  getAddressBook(params, isLoadmore = false) {
    if (isLoadmore) {
      this.startLoadMore(params.page);
    } else {
      $(`.address-list .list-data`, this.element).html("");
    }
    this.startLoading();
    apiGetAddressBook(params,
      (data) => {
        if (data && data.data && data.data.length > 0) {
          let addressBooks = Address.fromApiArray(data.data);
          this.paging = Paging.fromApiObject(data.paging);
          this.listAddress = this.listAddress.concat(addressBooks);
          this.fillData(addressBooks, isLoadmore);
        } else {
          if (!isLoadmore) {
            $(".modal-content", this.element).addClass("empty");
          }
        }
        if (isLoadmore) {
          this.stopLoadMore();
        }
        this.stopLoading();
      }, (error) => {
        this.stopLoading();

        if (isLoadmore) {
          this.stopLoadMore();
        }
      })
  }

  /**  @param {[Address]} data */
  fillData(data = [], isLoadmore = false) {
    if (!isLoadmore) {
      $(".modal-content", this.element).removeClass("empty");
      $(".address-list .list-data", this.element).html("");
      this.listRadio = [];
      // if (!this.selectedId) {
      //   let primaryAddress = data.find(item => item.addressType === GLOBAL_CONSTANTS.ADDRESS_TYPE.PRIMARY);
      //   this.selectedId = primaryAddress?.id;
      // }
      // let selectedAddress = data.find(item => item.id === this.selectedId);
      // if (selectedAddress) {
      //   data = [
      //     selectedAddress, ...data.filter(item => item.id !== this.selectedId),
      //   ]
      // }
    }

    data.forEach(element => {
      this.listRadio.push(new AddressItem({
        parent: $(".address-list .list-data", this.element),
        address: element,
        isSelect: true,
        hideRemove: true,
        selectedId: this.selectedId,
        isModal: true,
        onSelect: (id) => {
          this.selectedId = id;
          $(`.group-button .btn-select`, this.element).attr("disabled", false);
          this.deactiveAddressList(id);
        },
        onEdit: (id) => {
          let currentAddress = this.listRadio.find(item => item.getAddress().id === id);
          this.addressForm.fillData(currentAddress.getAddress());
          $(".modal-content", this.element).attr("type", "required-form").attr("mode", "edit");
        }
      }))
    });
  }

  onSave() {
    $(".btn-save", this.element).addClass("loading");
    let params = this.addressForm.getParamsAddress(false, true);
    delete params[Address.PARAMS.ADDRESS_TYPE];
    if (!params.id) {
      apiCreateAddressBook(params,
        (data) => {
          let newAddress = Address.fromApiObject(data.data);
          this.selectedId = newAddress.id;
          this.listAddress.unshift(newAddress);
          this.fillData(this.listAddress);
          this.addressForm.resetAddress();
          $(".modal-content", this.element).attr("type", "");
          $(".btn-save", this.element).removeClass("loading");
        },
        (error) => {
          $(".message", this.element).text(getMessage(error));
          $(".btn-save", this.element).removeClass("loading");
        }
      )
    } else {
      apiUpdateAddressBook(params.id, params,
        (data) => {
          let adddressEdit = this.addressForm.getDataAddress();
          adddressEdit.id = this.addressForm.getId();

          for (let index = 0; index < this.listRadio.length; index++) {
            let currrentAddress = this.listRadio[index];
            if (currrentAddress.getAddress().id === adddressEdit.id) {
              currrentAddress.fillData(adddressEdit);
              this.listAddress[index] = adddressEdit;
              break;
            }
          }
          this.addressForm.resetAddress();
          $(".modal-content", this.element).attr("type", "");
          $(".btn-save", this.element).removeClass("loading");
        },
        (error) => {
          $(".message", this.element).text(getMessage(error));
          $(".btn-save", this.element).removeClass("loading");
        }
      )
    }
  }

  deactiveAddressList(id) {
    this.listRadio.forEach(element => {
      if (element.address.id !== id) {
        element.setSelected(false);
      }
    });
  }

  setUpLoading() {
    for (let index = 0; index < 4; index++) {
      new AddressItem({
        parent: $(".list-data-loading", this.element),
        isLoading: true,
        className: "animated-background-dark"
      })
    }
  }

  startLoading() {
    $(".address-list-box", this.element).addClass("loading");
  }

  stopLoading() {
    $(".address-list-box", this.element).removeClass("loading");
  }

  startLoadMore(paging) {
    $(".address-list", this.element).addClass("load-more");
  }

  stopLoadMore() {
    $(".address-list", this.element).removeClass("load-more");
  }

  show() {
    $(".modal-content", this.element).attr("type", "").attr("mode", "").removeClass("empty");
    $("html, body").css("overflow", "hidden");
    this.element.modal("show");
  }

  hide() {
    this.element.modal("hide");
  }
}

export default AddressModal;